import React, { memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { PageHeader, Form, Button, message, Space, Input } from 'udesk-ui';
import { CopyButton } from 'src/components/pages/components/quality-score/components/CopyButton';
import styled from 'styled-components';
import {
    getCompanysIntelligentPartnerWebPagePlugin,
    postCompanysIntelligentPartnerWebPagePlugin,
} from 'src/api/companys/intelligent/partner/webPage/plugin';
import { getCompanysIntelligentPartnerWebPagePluginGenerate } from 'src/api/companys/intelligent/partner/webPage/plugin/generate';
import UdeskLocales from 'UdeskLocales';
import { WebPagePluginConfig1 } from 'src/api/types';

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
};

const tailLayout = {
    wrapperCol: { offset: 4 },
};

const PageContentWrapper = styled.div`
    padding-left: 120px;
`;

interface FormModel extends WebPagePluginConfig1 {}

const Template = memo(() => {
    const [form] = Form.useForm<FormModel>();

    const [text, setText] = useState<string>();

    const [initialValues] = useState<{ pluginAddress?: string }>({});

    const { run: getUrl } = useRequest(() => getCompanysIntelligentPartnerWebPagePlugin(), {
        onSuccess: (res) => {
            setText(res.data?.pluginAddress);
            form.setFieldsValue({
                pluginAddress: res.data?.pluginAddress,
                uniqueId: res.data?.uniqueId,
            });
        },
    });

    const { run: onGen } = useRequest(() => getCompanysIntelligentPartnerWebPagePluginGenerate(), {
        manual: true,
        onSuccess: (res) => {
            setText(res.data?.pluginAddress);
            form.setFieldsValue({
                pluginAddress: res.data?.pluginAddress,
                uniqueId: res.data?.uniqueId,
            });
        },
    });

    const onFinish = () => {
        const values = form.getFieldsValue();
        postCompanysIntelligentPartnerWebPagePlugin({
            pluginAddress: values.pluginAddress,
            uniqueId: values.uniqueId,
        })
            .then(() => {
                message.success(
                    /* 保存成功 */ UdeskLocales['current'].pages.admin.system.coachSpeechRecognition
                        .saveSuccessful
                );
            })
            .finally(() => {
                getUrl();
            });
    };

    return (
        <div className="udesk-qa-web-page">
            <PageHeader className="udesk-qa-web-page-header" title={/* 网页插件 */UdeskLocales['current'].pages.admin.system.webPlugin.webPlugin} />

            <div className="udesk-qa-web-page-body">
                <div
                    className="udesk-qa-web-page-body-root qa-page-admin-systom-index"
                    style={{ padding: 16 }}
                >
                    <PageContentWrapper>
                        <Form
                            form={form}
                            onFinish={onFinish}
                            {...layout}
                            initialValues={initialValues}
                        >
                            <Form.Item wrapperCol={{ offset: 4 }}>
                                <Button type="primary" onClick={() => onGen()}>{/* 生成链接 */}{UdeskLocales['current'].pages.admin.system.webPlugin.generateLink}</Button>
                            </Form.Item>

                            <Form.Item noStyle name="uniqueId">
                                <Input hidden />
                            </Form.Item>

                            <Form.Item label={/* 链接 */UdeskLocales['current'].pages.admin.system.webPlugin.link} required>
                                <Space>
                                    <Form.Item
                                        name="pluginAddress"
                                        rules={[{ required: true, message: /* 请输入链接 */UdeskLocales['current'].pages.admin.system.webPlugin.pleaseEnterALink }]}
                                        noStyle
                                    >
                                        <Input
                                            style={{ width: 500 }}
                                            onChange={(e) => setText(e.target.value)}
                                            disabled
                                        />
                                    </Form.Item>
                                    <CopyButton text={text} />
                                </Space>
                            </Form.Item>

                            <Form.Item {...tailLayout}>
                                <Space>
                                    <Button type="primary" htmlType="submit">
                                        {/* 保存 */}
                                        {
                                            UdeskLocales['current'].pages.admin.system
                                                .coachSpeechRecognition.preserve
                                        }
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </PageContentWrapper>
                </div>
            </div>
        </div>
    );
});

export default Template;
